import React from "react";
import { Skill, SkillFlag, getMaxSkillLevel } from "./SkillData";

import "./SkillOption.scss";
import { SkillLevels } from "./SkillSimulator";
import { Draggable } from "./Util";

// @ts-ignore - parcel image import
import activeSkillIcon from "./mastery-active-skill.png";

export interface SkillOptionProps {
    skill: Skill;
    levels: SkillLevels;
    selected: boolean;
    disabled: boolean;
    masteryOpen?: boolean;

    onLevelChange?: (id: number, lvl: number) => void;
    onSkillSelected?: (id: number) => void;
    onSkillMasteryAddRequest?: (id: number) => void;
}

function isProbablyMobile() {
    return window.outerWidth <= 680;
}

export class SkillOption extends React.Component<SkillOptionProps> {
    constructor(props: SkillOptionProps) {
        super(props);
        this.onClick = this.onClick.bind(this);
        this.onContextMenu = this.onContextMenu.bind(this);
    }
    getCurrentLevel() {
        return this.props.levels[this.props.skill.id] ?? 0;
    }
    getMaxLevel() {
        return getMaxSkillLevel(this.props.skill);
    }
    onClick(e: React.MouseEvent) {
        e.preventDefault();
        if (this.props.masteryOpen) {
            const skill = this.props.skill;
            const isActive = (skill.attrs & SkillFlag.SPELL) != 0;
            const ownPoints = this.getCurrentLevel();
            if (isActive && ownPoints > 0 && this.props.onSkillMasteryAddRequest) {
                this.props.onSkillMasteryAddRequest(this.props.skill.id);
            }
            return;
        }

        if (e.ctrlKey || this.props.selected) {
            if (this.props.disabled) return;

            const max = this.getMaxLevel();
            const addLevel = e.ctrlKey ? max : 1;
            const newLevel = Math.min(max, this.getCurrentLevel() + addLevel);
            if (this.props.onLevelChange) this.props.onLevelChange(this.props.skill.id, newLevel);
        } else {
            if (this.props.onSkillSelected) this.props.onSkillSelected(this.props.skill.id);
        }
    }
    onContextMenu(e: React.MouseEvent) {
        if (this.props.disabled || this.props.masteryOpen) return;

        e.preventDefault();
        const max = this.getMaxLevel();
        const subtractLevel = e.ctrlKey ? max : 1;
        const newLevel = Math.max(0, this.getCurrentLevel() - subtractLevel);
        if (this.props.onLevelChange) this.props.onLevelChange(this.props.skill.id, newLevel);
    }
    render(): React.ReactNode {
        const skill = this.props.skill;
        const isActive = (skill.attrs & SkillFlag.SPELL) != 0;
        const ownPoints = this.getCurrentLevel();
        const maxPoints = this.getMaxLevel();
        const progress = Math.floor((ownPoints / maxPoints) * 10);
        const masteryDisabled = (!isActive || ownPoints == 0) && this.props.masteryOpen && !this.props.disabled;
        const cl = `skill-simulator-option pts-${progress}${this.props.selected && !this.props.masteryOpen ? " selected" : ""}${masteryDisabled ? ` disabled` : ``}`
        return <div onClick={this.onClick} onContextMenu={this.onContextMenu} className={cl}>
            <div className="skill-name">
                {this.props.skill.name}
            </div>
            <div className="skill-bottom">
                <div className={`skill-active${isActive ? " active" : ""}`}></div>
                <div className="skill-pts">{ownPoints}/{maxPoints}</div>
            </div>
        </div>
    }
}
